import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { useClientContext } from "../../context/ClientContext";

const SchemeDashboardX = lazy(() => import("./SchemeDashboardX"));

// Your routes
const SCHEMEDASH_X_ROUTES: RouteObject[] = [
  {
    path: `/private/schemes/:clientType`, // Use a placeholder for clientType
    element: React.createElement(SchemeDashboardX),
  },
];

// Define a functional component
const SchemeDashboardRoutes = () => {
  const { clientType, updateClientType } = useClientContext();

  // Update the path dynamically
  SCHEMEDASH_X_ROUTES[0].path = `/private/schemes/${clientType}`;

  return SCHEMEDASH_X_ROUTES;
};

export default SchemeDashboardRoutes;
export { SCHEMEDASH_X_ROUTES }; // Export the routes array
